export default __webpack_public_path__ + "static/media/social-media-2.7ec23fea.png";